import { render, staticRenderFns } from "./batch-result.vue?vue&type=template&id=fca67898&scoped=true"
import script from "./batch-result.vue?vue&type=script&lang=js"
export * from "./batch-result.vue?vue&type=script&lang=js"
import style0 from "./batch-result.vue?vue&type=style&index=0&id=fca67898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca67898",
  null
  
)

export default component.exports